<template>
    <iframe :src="'https://v4.biwee.fr/api/dashboard/' + tokenGuid"
            v-if="tokenGuid !== null"
            scrolling="no"
            style="width:100%;
            height:800px;
            border:none;">
    </iframe>
</template>

<script>
import {mapState} from "vuex"

export default {
    name: "CmajStat",
    data() {
        return {
            tokenGuid: null,
            biweeToken: process.env.VUE_APP_BIWEE_CMAJ_TOKEN
        }
    },
    methods: {
        getBiweeGUID() {
            this.$global.loading = true

            this.$http.get('auth/account/biwee-guid/' + this.biweeToken).then(res => {
                this.tokenGuid = res.body.data.guid

                this.$global.loading = false
            })
        }
    },
    computed: {
        ...mapState('account', ['account']),
    },
    created() {
        this.getBiweeGUID()
    }
}
</script>